import React, {Component} from "react";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {setCurrentPageTitle} from "./../../components/Header/actions/headerActions";
import {getTranslate} from "react-localize-redux";
import {withStyles} from "@material-ui/core/styles";
import PageContent from "../../containers/PageContent/PageContent";
import Grid from "@material-ui/core/Grid";
import CustomButton from "./../../containers/CustomButton/CustomButton";
import CustomTranslation from "../../components/CustomTranslation/CustomTranslation";
import PageFiltersItems from "../../components/PageFiltersItems/PageFiltersItems";
import {
    fetchItemDataReport,
    fetchItemDataReportSCV,
    setItemDataReportFilter,
    clearFilters
} from './actions/itemDataActions';
import {fade} from "./../../../node_modules/@material-ui/core/styles/colorManipulator";
import {isEmpty} from "lodash";
import moment from 'moment';
import {
    getBooleanShopProperty,
    getFiltersAppropriateMarkets,
    getReturnReasons,
    isNeedToShowMarket,
    isNeedToShowMarketLanguage,
    toFixedCurrency,
    createTemporaryLinkElement,
    getTableHeight
} from "./../../utilites";
import CustomTable from "./../../components/CustomTable/CustomTable";
import {Redirect} from "react-router";
import defaultRequestConst from "../Returns/defaultRequestConst";

const styles = (theme) => {
    return ({
        exportCSVBtn: {
            background: fade(theme.palette.brand.btnColors.reject, 0.5),
            '&:hover': {
                background: theme.palette.brand.btnColors.reject
            }
        }
    })
};

class ItemData extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentPage: 0,
            pageSizeOption: defaultRequestConst.limit,
        };
    }

    /**
     * getFiltersValue {Function}
     * @description - get default values for Filters
     * @return {Object}
     *
     * */
    getFiltersValue = (part) => {
        let {filters={}} = this.props;
        let {startDate, endDate, status, type, reason, baseCurrency, market} = filters;

        switch(part) {
            case 1:
                return {
                    0: [startDate, endDate],
                    1: status,
                    2: reason
                };
            case 2:
                return {
                    0: type,
                    1: baseCurrency,
                    2: market
                };
            default:
                return {}

        }
    };

    /**
     * getDisabledStates {Function}
     * @description - get default enabled/disabled states for Filters
     * @return {Object}
     *
     * */
    getDisabledStates = (part) => {
        switch(part) {
            case 1:
                return {
                    0: false,
                    1: false,
                    2: false
                };
            case 2:
                return {
                    0: false,
                    1: false,
                    2: false
                };
            default:
                return {}

        }
    };

    /**
     * changeFilterAction {Function}
     * @description - change filter action value
     *
     * */
    changeFilterAction = (value, item) => {
        let {label=''} = item;
        console.log(label, value)

        switch(label) {
            default:
                this.props.setItemDataReportFilter(label, value);
                break;
        }
    };

    /**
     * clearFilterAction {Function}
     * @description - clear filter action value
     *
     * */
    clearFilterAction = (value, item) => {
        let {label='', clearedValue=''} = item;

        switch(label) {
            default:
                this.props.setItemDataReportFilter(label, clearedValue);
                break;
        }
    };

    /**
     * getFilterShopNames {Function}
     * @description - generates appropriate options for Market dropdown in Filters
     * @return {Object}
     *
     * */
    getFilterShopNames = () => {
        let {mainPropertiesState} = this.props;
        return getFiltersAppropriateMarkets(mainPropertiesState, isNeedToShowMarket(mainPropertiesState), isNeedToShowMarketLanguage(mainPropertiesState));
    };

    getReturnReasons = () => {
        let {mainPropertiesState} = this.props;
        return getReturnReasons(mainPropertiesState);
    };

    /**
     * fetchReport {Function}
     * @description - get filtered reports
     *
     * */
    fetchReport = () => {
        this.props.fetchItemDataReport({
            route: 'getItemDataReport',
            isWithGetParams: true,
            requestData: this.getFiltersForRequest()
        });
    };

    /**
     * fetchCSVReport {Function}
     * @description - get filtered reports
     *
     * */
    fetchCSVReport = () => {
        this.props.fetchItemDataReportSCV({
            route: 'getItemDataReportCsv',
            isWithGetParams: true,
            requestData: this.getFiltersForRequest()
        });
    };

    /**
     * getFiltersForRequest {Function}
     * @description - get data for request to ger report based on filters values
     * @return {Object}
     * */
    getFiltersForRequest = () => {
        let {filters} = this.props;
        let requestData = {};

        for(let filter in filters) {
            switch(filter){
                case 'startDate':
                    requestData['from'] = moment(new Date(filters[filter]).setHours(0,0,0,0)).add(moment().utcOffset(), 'minutes').toISOString();
                    break;
                case 'endDate':
                    requestData['to'] =  moment(new Date(filters[filter]).setHours(23,59,59,59)).add(moment().utcOffset(), 'minutes').toISOString();
                    break;
                case 'type':
                    requestData['returnType'] = filters[filter];
                    break;
                case 'reason':
                    requestData['reclamationReason'] = filters[filter];
                    break;
                case 'market':
                    requestData['shopId'] = filters[filter];
                    break;
                case 'baseCurrency':
                    requestData['currency'] = filters[filter];
                    break;
                default:
                    requestData[filter] = filters[filter];
                    break;
            }
        }


        return requestData;
    };

    /**
     * getTableData {Function}
     * @description - return data array to render in returns table
     * @return {Array}
     *
     * */
    getTableData = (data) => {
        return isEmpty(data.toJSONView()) ? [] : data.getField('response')
    };

    /**
     * handleTableRowClick {Function}
     * @description - function return object with action which fires when click on specific table's row
     * @return {Object}
     *
     * */
    handleTableRowClick = (state, rowInfo) => {
        return {
            onClick: (e) => {}
        }
    };

    getVieFromObject = (object, isConditions=false) => {
        let attributes = [];
        let prefix = isConditions ? 'return.order.details.conditions.' : 'return.order.details.reclamation.reason.';

        if(object && Object.keys(object).length) {
            for(let i in object) {
                attributes.push({
                    name: i,
                    value: object[i]
                })
            }
        } else {
            return '-'
        }

        return attributes.map((attr, key)=>{
            return(
                <div key={key}>
                    <CustomTranslation id={`${prefix+attr.name}`} />: {`${attr.value}`}
                </div>
            )
        })
    };

    /**
     * renderTable {Function}
     * @description - render table using data from server side
     * @return {React Component}
     *
     * */
    renderTable = (tableDataP) => {
        let {data, isLoading} =  this.props;
        let prefix = 'products.report.list.columns';
        let tableData = tableDataP || this.getTableData(data);
        let columns = [
            {
                Header: <CustomTranslation id={`${prefix}.productId`}/>,
                id: 'productExternalId',
                accessor: (row)=>{ return row.productExternalId},
                Cell: ({row})=>{ return row.productExternalId}
            },
            {
                Header: <CustomTranslation id={`${prefix}.name`}/>,
                id: 'productName',
                accessor: (row)=>{ return row.productName},
                Cell: ({row})=>{ return row.productName}
            },
            {
                Header: <CustomTranslation id={`${prefix}.conditions`}/>,
                id: 'conditions',
                accessor: (row)=>{
                    return row.conditions
                },
                sortingMethod: (a, b, c) => {
                    console.log(a, b, c)
                },
                Cell: ({row})=>{ return this.getVieFromObject(row.conditions, true)}
            },
            {
                Header: <CustomTranslation id={`${prefix}.reasons`}/>,
                id: 'reasons',
                accessor: (row)=>{ return row.reasons},
                Cell: ({row})=>{ return this.getVieFromObject(row.reasons)}
            },
            {
                Header: <CustomTranslation id={`${prefix}.total`}/>,
                id: 'total',
                accessor: (row)=>{ return row.total},
                Cell: ({row})=>{ return toFixedCurrency(row.total)}
            },
            {
                Header: <CustomTranslation id={`${prefix}.varTotal`}/>,
                id: 'varTotal',
                accessor: (row)=>{ return row.varTotal},
                Cell: ({row})=>{ return toFixedCurrency(row.varTotal)}
            }
        ];

        return <CustomTable
            className={'-highlight -striped'}
            data={tableData}
            columns={columns}
            loading={isLoading}
            isLoading={isLoading}
            getTrProps={this.handleTableRowClick}
            pageSize={tableData && tableData.length ? tableData.length : 0}
            style={{
                // This will force the table body to overflow and scroll, since there is not enough room
                height: getTableHeight(tableData)
            }}
            showPagination={false}
            isPaginationActive={false}
        />
    };

    /**
     * downloadCSVReport {Function}
     * @description - enable possibility to download csv file
     *
     * */
    downloadCSVReport = (csvDataModel) => {
        let csvData = csvDataModel.getField('response');
        let separator = ',';
        if(csvDataModel && csvData) {
            let reader = new FileReader();
            let fileName = `ReturnadoItemsReport.csv`;
            let blob = new Blob([`sep=${separator}\n${csvData}`], {type : 'text/csv;charset=utf-8'});

            reader.onload = () => {createTemporaryLinkElement(fileName, blob)};

            reader.readAsText(blob);
        }
    };

    componentDidMount() {
        let {pageName} = this.props;
        this.props.setCurrentPageTitle(pageName)
    }

    componentDidUpdate (prevProps) {
        if(prevProps.csvData !== this.props.csvData) {
            this.downloadCSVReport(this.props.csvData);
        }
    };

    componentWillUnmount() {
        this.props.clearFilters();
    }

    render (){
        let {isFoldedOpen, isLoading, classes, data} = this.props;
        let tableData = this.getTableData(data);
        return (
            getBooleanShopProperty(this.props, 'reports.page.enabled')
                ?
                <div className='b-app__page b-item-data-report-page'>
                    <PageContent isFoldedOpen={isFoldedOpen} classNameCustom='b-page-content--item_data_report'>
                        <div className="b-app__page_body">
                            <div className="b-app__body_item">
                                <div className="b-item-data-report-page__description">
                                    <h2 className={`b-app__page_content_title b-app__page_content_title--center_align`}>
                                        <CustomTranslation id={'products.report.list.title'}/>
                                    </h2>
                                </div>
                                <Grid container className="b-item-data-report-page__flex-grow" spacing={0}>
                                    <Grid item xs={7} md={9} lg={10} className="b-returns-item__block">
                                        <div className='b-item-data-report-page__filters_section'>
                                            <PageFiltersItems
                                                pageId="itemDataReport1part"
                                                classStyles="b-item-data-report-page__filters"
                                                defaultValues={this.getFiltersValue(1)}
                                                disabledStates={this.getDisabledStates(1)}
                                                changeAction={this.changeFilterAction}
                                                clearAction={this.clearFilterAction}
                                                isLabeled={true}
                                                replaceFilter={{
                                                    'returns.report.list.columns.reason': this.getReturnReasons()
                                                }}
                                            />
                                        </div>
                                        <div className='b-item-data-report-page__filters_section'>
                                            <PageFiltersItems
                                                pageId="itemDataReport2part"
                                                classStyles="b-item-data-report-page__filters"
                                                defaultValues={this.getFiltersValue(2)}
                                                disabledStates={this.getDisabledStates(2)}
                                                changeAction={this.changeFilterAction}
                                                clearAction={this.clearFilterAction}
                                                isLabeled={true}
                                                replaceFilter={{
                                                    'products.report.list.columns.market': this.getFilterShopNames()
                                                }}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item xs={5} md={3} lg={2} className="b-returns-item__block">
                                        <div className='b-item-data-report-page__btn_wrapper'>
                                            <CustomButton
                                                type='button'
                                                variant='contained'
                                                fullWidth={true}
                                                color='primary'
                                                aria-label={<CustomTranslation
                                                    id='products.report.list.columns.generate'/>}
                                                loading={isLoading}
                                                name={<CustomTranslation id='products.report.list.columns.generate'/>}
                                                onClick={this.fetchReport}
                                            />
                                        </div>
                                        <div className='b-item-data-report-page__btn_wrapper'>
                                            <CustomButton
                                                type='button'
                                                variant='contained'
                                                fullWidth={true}
                                                color='primary'
                                                aria-label={<CustomTranslation id='products.report.list.columns.csv'/>}
                                                loading={isLoading}
                                                isdisabled={tableData && !tableData.length}
                                                name={<CustomTranslation id='products.report.list.columns.csv'/>}
                                                className={classes.exportCSVBtn}
                                                onClick={this.fetchCSVReport}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            </div>
                            <div className="b-app__body_item">
                                <div className="b-item-data-report-page__counter">
                                    {
                                        tableData && tableData.length ?
                                            <CustomTranslation id='returns.report.counter' data={{
                                                returnLength: tableData && tableData.length ? tableData.length : 0,
                                                totalReturnLength: tableData.length
                                            }}/>
                                            :
                                            ''
                                    }
                                </div>
                                <div className="b-app__table_wrapper">
                                    {this.renderTable(tableData)}
                                </div>
                            </div>
                        </div>
                    </PageContent>
                </div>
                :
                <Redirect to="/"/>
        )
    };
}

function mapStateToProps(state) {
    return {
        ...state.itemDataReportState,
        mainPropertiesState: state.mainPropertiesState,
        translate: getTranslate(state.localize)
    };
}

function matchDispatchToProps(dispatcher) {
    return bindActionCreators(
        {
            setCurrentPageTitle,
            setItemDataReportFilter,
            fetchItemDataReport,
            fetchItemDataReportSCV,
            clearFilters
        },
        dispatcher,
    );
}

export default  withStyles(styles)(connect(mapStateToProps, matchDispatchToProps)(ItemData));